// extracted by mini-css-extract-plugin
module.exports = {"root":"_2tv7Y","strip":"tc5At"};